import { createUniqKey } from 'Utils';

export interface ILocation {
  id: string,
  name: string,
  description: string,
  address: string,
  city: string,
  country: string,
  postCode: string,
  point: {
    coordinates: [ number, number ],
  },
  createdAt: Date | null,
}

export class Location {
  public _key: string;
  public id: string;
  public name: string;
  public description: string;
  public address: string;
  public city: string;
  public country: string;
  public postCode: string;
  public point: {
    coordinates: [ number, number ],
  };
  public createdAt: Date | null;

  constructor(data: ILocation) {
    this._key = createUniqKey();

    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.address = data.address;
    this.country = data.country;
    this.city = data.city;
    this.postCode = data.postCode;
    this.point = data.point;
    this.createdAt = data.createdAt ? new Date(data.createdAt as unknown as number * 1000) : null;

  }
}

export const createNewLocation = (data: Partial<ILocation> = {}): Location => new Location({
  id: data.id || 'new',
  name: data.name || '',
  description: data.description || '',
  address: data.address || '',
  city: data.city || '',
  country: data.country || '',
  postCode: data.postCode || '',
  point: data.point || { coordinates: [50, 10] },
  createdAt: data.createdAt || null,
});
